"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applySorting = void 0;
const applySorting = (array, oldIndex, newIndex) => {
  const value = array[oldIndex];
  const reduced = [...array];
  reduced.splice(oldIndex, 1);
  reduced.splice(newIndex, 0, value);
  return reduced;
};
exports.applySorting = applySorting;